/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IFooterViewProps } from '@msdyn365-commerce-modules/footer';
import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

/**
 *
 * FooterItemView component
 * @extends {React.PureComponent<IFooterViewProps>}
 */
export class FooterItemView extends React.PureComponent<IFooterViewProps> {
    public render(): JSX.Element | null {
        const { FooterItem } = this.props;
        return(
            <Module {...FooterItem}>
                {this._renderElement(this.props)}
            </Module>
        );
    }

    private _renderElement(props: IFooterViewProps): React.ReactNode | null {
        const {heading, HeadingContainer,Link, linkText, image} = props;
        const { link } = this.props.config;
        if(heading) {
            return (<Node {...HeadingContainer}> {heading} </Node>);
        } else if(Link && this._formatLinkData(Link)) {
                return (
                    <Node {...Link} aria-label={link?.ariaLabel}>
                        {linkText}
                        {image}
                    </Node>
                );
        }
        return(
            <>
                {linkText}
                {image}
            </>
        );
    }

    private _formatLinkData = (Link: INodeProps) => {
        if(Link.href === undefined) {
            return Link;
        }

        const path: string = (Link.href as Msdyn365.ILinkData).destinationUrl || (Link.href as string);
        const newUrl = new URL(path, this.props.context.request.url.requestUrl).href;
        Link.href = newUrl;
        return Link;
    };
}

export default FooterItemView;